var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwap2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 19L5.70708 16.7071C5.31655 16.3166 5.31655 15.6834 5.70708 15.2929L7.99997 13M5.99997 16L18 16M17 10L19.2929 7.70711C19.6834 7.31658 19.6834 6.68342 19.2929 6.29289L17 4M19 7L6.99997 7",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwap2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/swap-2.b1cc152a5edb800e8bdc320b479edda5.svg";